var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('business-details-form',{attrs:{"business":_vm.currentBusiness,"flat":""},on:{"saved":_vm.businessSaved},scopedSlots:_vm._u([{key:"actions",fn:function(ref){
var loading = ref.loading;
var submitting = ref.submitting;
var submit = ref.submit;
return [_vm._t("actions",null,null,{ loading: loading, submitting: submitting, submit: submit })]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }